import { graphql, compose } from 'react-apollo'
import { Layout, Input, Table, Form, Button, Divider } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import XLSX from 'xlsx'

import hookTrackingMutation from '../graphql/mutations/hookTracking'
import searchTrackingsQuery from '../graphql/queries/searchTrackings'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item

class SendTrackingByFile extends Component {
  state = {
    data: [],
    loading: false,
  }
  handleFileChange = (event) => {
    const { files } = event.target
    const file = files[0]
    const reader = new FileReader()
    reader.onload = (e) => {
      const f = e.target.result
      const workbook = XLSX.read(f, { type: 'binary' })
      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]
      const rows = XLSX.utils.sheet_to_json(worksheet)
      const data = rows.filter(row => !!row['Tracking code']).map(row => ({
        carrier: row['Tracking type'] || 'thaipost', code: row['Tracking code'], labelId: row['Label ID'], recipient: row.Recipient,
      }))
      this.setState({ data })
    }
    reader.readAsBinaryString(file)
  }
  sendTrackingsByFile = async () => {
    this.setState({ loading: true })
    const { hookTracking } = this.props
    const { data } = this.state
    const sendTrackingWithFile = async (record) => {
      const { data: { trackings } } = await this.props.trackings.refetch({ code: record.code })
      if(trackings[0].status !== 'Delete'){
        await hookTracking({ variables: { labelId: record.labelId, trackingId: trackings[0]._id } })
      }
    }
    await data.asyncForEach(async (record) => {
      try {
        const { carrier, code, labelId } = record
        await sendTrackingWithFile({ carrier, code, labelId })
      } catch (err) {
        console.log(err)
      }
    })
    alert('Send Tracking Completed !')
    this.setState({ loading: false })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const { data, loading } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Label ID',
        dataIndex: 'labelId',
        key: 'labelId',
      },
      {
        title: 'Tracking',
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: 'Carrier',
        dataIndex: 'carrier',
        key: 'carrier',
      },
      {
        title: 'Recipient',
        dataIndex: 'recipient',
        key: 'recipient',
      },
    ]
    return (
      <Layout>
        <Navbar selected="import:3" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <h3>Send Tracking By File</h3>
            <Form>
              <FormItem
                {...formItemLayout}
                label="File"
              >
                {getFieldDecorator('file', {
                  rules: [{ required: true, message: 'Please input excel file!' }],
                })(
                  <Input type="file" onChange={this.handleFileChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" onClick={this.sendTrackingsByFile} disabled={data.length === 0} loading={loading}>Check And Send Trackings</Button>
              </FormItem>
            </Form>
            <Divider />
            {data.length > 0 ? (
              <div>
                <h2>Preview</h2>
                <Table
                  rowKey="labelId"
                  dataSource={data}
                  columns={columns}
                  pagination={{ pageSize: 20 }}
                  size="small"
                />
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
SendTrackingByFile.propTypes = {
  form: PropTypes.shape(),
}
SendTrackingByFile.defaultProps = {
  form: {},
}

export default compose(
  graphql(hookTrackingMutation, { name: 'hookTracking' }),
  graphql(searchTrackingsQuery, { name: 'trackings', options: { variables: { code: '' } } }),
  Form.create()
)(SendTrackingByFile)



// WEBPACK FOOTER //
// ./src/pages/sendtrackingbyfile.js